import StudentDashboard from '../../components/dashboard/StudentDashboard'

const Dashboard = () => {
  return <StudentDashboard />
}

export default Dashboard